import type { PluginConfig } from "@/api/plugins";

export type PluginStatusFilter = "all" | "enabled" | "disabled";

export const STATUS_FILTER_TABS: PluginStatusFilter[] = [
  "all",
  "enabled",
  "disabled",
];

export function countEnabledPlugins(plugins: PluginConfig[]): number {
  return plugins.filter((p) => p.enabled).length;
}

export interface PluginFilterOptions {
  search?: string;
  status?: PluginStatusFilter;
}

export function filterPlugins(
  plugins: PluginConfig[],
  { search = "", status = "all" }: PluginFilterOptions,
): PluginConfig[] {
  const q = search.trim().toLowerCase();

  return plugins.filter((p) => {
    if (status === "enabled" && !p.enabled) return false;
    if (status === "disabled" && p.enabled) return false;
    if (q) {
      return (
        p.name.toLowerCase().includes(q) ||
        p.description.toLowerCase().includes(q) ||
        p.pluginId.toLowerCase().includes(q)
      );
    }
    return true;
  });
}
